<template>
  <div class="hidden sm:block overflow-y-scroll">
    <div
      @mouseover="hover=true;"
      @mouseleave="reduceMenu"
      class="flex flex-col bg-white min-h-full
      transition-all duration-100 ease-in
      w-max-content w-max max-w-64 xxl:max-w-72 2xl:max-w-80 relative z-10"
      :class="{'absolute xl:relative': hover}"
    >
      <ul class="ml-5 mt-32">
        <li
          class="list-none"
        >
          <ul class="pl-3">
            <!-- BEGIN List pages -->
            <li
              v-for="menu of staticMenus"
              :class="{'text-gray-900 font-normal': true}"
            >
              <router-link
                :to="{ name: 'HelpContact'}"
                :key="menu.libelle"
                v-if="menu.pageName"
                active-class="border-r-4 border-indigo-600 py-5 font-semibold"
                class="hover:font-normal transition-all ease-in-out duration-150 block py-3 pr-10 font-light"
              >
                {{ menu.libelle }}
              </router-link>
              <a
                :href="menu.external"
                v-else-if="menu.external"
                :target="menu.target"
                class="py-5 pr-10 block font-light"
              >{{
                menu.libelle
              }}</a>
            </li>
            <!-- END List pages -->
          </ul>
        </li>
        <!-- END List modules -->
      </ul>
    </div>
  </div>
</template>

<script>
import Icon from './Icon';
import Layout from '../mixins/Layout';

export default {
  components: {
    Icon
  },
  mixins: [Layout],
  data: function () {
    return {
      hover: true,
      staticMenus: [
        // {external: '#', libelle: 'Tutoriels vidéo'},
        // {external: 'https://www.youtube.com/', libelle: 'Chaîne Youtube', target: '_blank'},
        // {external: '#', libelle: 'Wiki'},
        {pageName: 'HelpContact', libelle: 'Contact'},
      ]
    };
  },
  mounted() {
    if (window.matchMedia('(max-width: 1279px)').matches) { //If screen too small, legend at bottom
      this.hover = false;
    } else {
      this.hover = true;
    }
  },
  methods: {
    reduceMenu() {
      if (window.matchMedia('(max-width: 1279px)').matches) {
        this.hover = false;
      }
    },
  },
};
</script>
